import cookies from "./util.cookies";
import db from "./util.db";
import log from "./util.log";
import { downloadFile } from "./util.download";
import { formatDate } from "@/assets/js/mUtils";

const util = {
  cookies,
  db,
  log,
  videoTypes: [".avi", ".flv", ".mp4", ".mov"],
  imgTypes: [".jpg", ".png", ".jpg", ".jpeg", ".png", ".ico", ".bmp"],
};
/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  const processTitle = process.env.VUE_APP_TITLE || "D2Admin";
  window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ""}`;
};

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  var a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("target", "_blank");
  a.setAttribute("id", "d2admin-link-temp");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(document.getElementById("d2admin-link-temp"));
};

util.UUID = function () {
  let d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

util.isSafePwd = function (pwd = "") {
  //长度大于等于8，大写字母、小写字母、数字的组合
  return !(pwd.length < 8 || !pwd.match(/[A-Z]/) || !pwd.match(/[a-z]/) || !pwd.match(/\d/));
};

//下载文件
util.downloadFile = downloadFile;

// 周开始时间
util.getWeekStartDate = function (date = new Date()) {
  let weekStartDate = new Date(date);
  weekStartDate.setDate(date.getDate() - date.getDay() + 1);
  //将时间格式化
  weekStartDate = formatDate(weekStartDate, "yyyy-MM-dd");
  return weekStartDate;
};

// 周结束时间
util.getWeekEndDate = function (date = new Date()) {
  let weekEndDate = new Date(date);
  weekEndDate.setDate(date.getDate() + (6 - date.getDay() + 1));
  //将时间格式化
  weekEndDate = formatDate(weekEndDate, "yyyy-MM-dd");
  return weekEndDate;
};

// 获取当前月份的第一天
util.getMonthStartDate = function (date = new Date()) {
  let monthStartDate = new Date(date);
  monthStartDate.setDate(1);
  //将时间格式化
  monthStartDate = formatDate(monthStartDate, "yyyy-MM-dd");
  return monthStartDate;
};

// 数组转树形
util.arrayToTree = function (items, config = {
    topId: 0,
    pidFieldName: 'pid',
    aggregate: false,
    aggregateField: [],
    hideEmptyChildren: false
}) {
    let map = {}
    for (const i of items) {
        if (!map[i[config.pidFieldName]]) {
            map[i[config.pidFieldName]] = []
        }
        map[i[config.pidFieldName]].push({...i})
    }
    let buildTree = (id) => {
        let data = map[id]
        if (data) {
            for (let i = 0; i < data.length; i++) {
                let children = buildTree(data[i].id)
                if (config.aggregate === true && children.length > 0) {
                    children.forEach((child => {
                        config.aggregateField.forEach((field) => {
                            if (!data[i][field]) {
                                data[i][field] = 0
                            }
                            data[i][field] += (child[field] || 0)
                        })
                    }))
                }
                if (!config.hideEmptyChildren || (config.hideEmptyChildren && children.length > 0)) {
                    data[i].children = children
                }
            }
            return data
        } else {
            return []
        }
    }
    return buildTree(config.topId)
}

// 格式化单个日期，将 YYYY-MM-DD 转换为 YYYYMMDD
util.formatDateToYYYYMMDD = function(dateString) {
  if (!dateString) return dateString;
  return dateString.replace(/-/g, '');
};

// 批量处理查询参数格式化查询参数中的日期
util.formatQueryDates = function(query, dateFields = ['startDay', 'endDay']) {
  const formattedQuery = { ...query };
  dateFields.forEach(field => {
    if (formattedQuery[field]) {
      formattedQuery[field] = util.formatDateToYYYYMMDD(formattedQuery[field]);
    }
  });
  return formattedQuery;
};

export default util;
